import '../global.js';
import * as Helper from './Helpers';
import gsap from 'gsap';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import Accordion from './Accordion.js';

class StoriesFilters {
	get defaultOptions() {
		return {
			container: document,
		};
	}

	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);
		this.isEnabled = true;
		this.simpleBar;
		this.isSimpleBar = false;
		this.applied = false;
		this.accordion = Accordion;
		this.mm = gsap.matchMedia();
		this.init();
		this.previousSearch = '';
	}

	init() {
		this.Filters();
		this.filterCount();
		this.searchAutocomplete();
		this.initTransition();
		this.createAccordion();
	}

	createAccordion() {
		this.accordion.create({
			speed: 0.5,
			element: '[data-accordion]',
			container: this.options.container
		});
	}

	destroyAccodion() {
		this.accordion.destroy();
	}

	initTransition() {
		// add transitioned data to already card
		$('.page-stories, .page-india-stories').find('.news-feed-grid .col').addClass('fade-in');
	}

	updateURL(sectors, series, locations) {
		const params = new URLSearchParams(location.search);

		if (sectors.length) {
			params.set('sector', sectors.join(','));
		} else {
			params.delete('sector');
		}

		if (series && series.length) {
			params.set('series', series.join(','));
		} else {
			params.delete('series');
		}

		if (locations && locations.length) {
			params.set('location', locations.join(','));
		} else {
			params.delete('location');
		}

		const newURL = `${location.pathname}?${params.toString()}`;
		history.pushState({}, '', newURL);
		window.barba.history.add(newURL, 'stories');
	}

	Filters() {

		$('.page-stories, .page-india-stories').find('.filter-wrap :checkbox').on('change', (e) => {
			let value = $(e.target).val();

			if (value === 'all') {
				$(e.target).closest('ul').find('li input').prop('checked', false);
				$(e.target).prop('checked', true);
			} else {
				$(e.target).parents('ul').find('.filter-all').prop('checked', false);
				if (
					!$(e.target)
						.closest('ul')
						.find('li input:not(.filter-all)')
						.is(':checked')
				) {
					$(e.target).closest('ul').find('.filter-all').prop('checked', true);
				}
			}

			this.getResults(this.getFilters());
			this.filterCount();
		});

		$('.page-stories, .page-india-stories').find('#reset-filters').on('click', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters());
		});

		$('.page-stories, .page-india-stories').find('#reset-filters-mobile').on('click', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters());
		});

		$(document).on(
			"click",
			".page-stories .ui-menu-item-wrapper, .page-india-stories .ui-menu-item-wrapper",
			(e) => {
				this.applied = true;
				this.previousSearch = $(e.target).text();
				this.getResults(this.getFilters());	
			}
		);

		$(document).on(
			"submit",
			".page-stories form.search, .page-india-stories form.search",
			(e) => {
				e.preventDefault();
				this.applied = true;
				this.previousSearch = $(e.target).find('input').val();
				this.getResults(this.getFilters());
			}
		);

		$(document).on('click', '.load-more-stories:not(.disable-click)', (e) => {
			$(e.target).addClass('disable-click');
			let slug = $(e.target).data('slug');
			let page = $(e.target).data('page');
			let scrollPosition = this.getScrollPosition();

			$(e.target)
				.html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="16px" height="16px" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid">
      <circle cx="12" cy="12" fill="none" stroke="#ffffff" stroke-width="2" r="8" stroke-dasharray="18.84955592153876 8.283185307179586">
      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 12 12;360 12 12" keyTimes="0;1"/>
      </circle>
      </svg>`);

			setTimeout(() => {
				this.loadMore(
					this.getFilters(),
					slug,
					parseInt(page) + 1,
					scrollPosition,
					e.target,
				);
			}, 200);
		});

		$('.page-stories, .page-india-stories').find('.filter-wrap #search').on('keyup', (e) => {

			if (!$('.filter-wrap #search').val() && this.applied) {
				this.previousSearch = '';
				this.getResults(this.getFilters());
				this.applied = false;
			}
			if ($('#search').val()) {
				$('form.search').addClass('filled');
			} else {
				$('form.search').removeClass('filled');
			}
		});

		$('.page-stories, .page-india-stories').find('.reset-field').on('click', (e) => {
			$('#search').val('');
			$('form.search').removeClass('filled');
			if (this.applied) {
				this.previousSearch = '';
				this.getResults(this.getFilters());
				this.applied = false;
			}
		});
	}

	// Fetch checked filters, search field and nonce
	getFilters() {
		let sectors = [];
		let series = [];
		let locations = [];

		$('#sector-filter input:checked').each((index, element) => {
			sectors.push($(element).val());
		});

		$('#series-filter input:checked').each((index, element) => {
			series.push($(element).val());
		});

		$('#location-filter input:checked').each((index, element) => {
			locations.push($(element).val());
		});

		let search = this.previousSearch;
		let nonce = $('#story-filters-nonce').val();
		return {sectors, series, locations, search, nonce};
	}

	// Ajax call
	getResults({sectors, series, locations, search, nonce}) {
		let pageId = $('.filter-wrap').data('page-id');
		let template = $('.stories-section').data('template');
		
		$('#smooth-wrapper').after('<div class="loading"></div>');
		this.destroyAccodion();
		setTimeout(() => {
			$.ajax({
				type: 'post',
				dataType: 'json',
				url: wp_ajax.ajaxurl,
				data: {
					action: 'stories_filters',
					pageId,
					nonce,
					sectors,
					series,
					locations,
					search,
					template,
				},
				success: (result) => {
					let html =
						result.html !== '\n'
							? result.html
							: '<div class="no-result">No results</div>';
					if (result.html) {
						$('.section-portfolio .accordion').html(html);
						Helper.OpenCloseNew();
						Helper.HoverClassOnParent();
						$('.loading').remove();
					}

					this.updateURL(sectors, series, locations);
					this.createAccordion();

					const parent = $('.page-stories, .page-india-stories').find('.col:not(.fade-in)').parent();
					const invert = 1;

					setTimeout(() => {
						const appended = $('.page-stories, .page-india-stories').find('.col:not(.fade-in)');

						gsap.set(appended, {alpha: 0});
						gsap.set(parent.parent(), {height: '100%'});

						gsap
							.timeline({
								onStart: () => {
									if (!appended.hasClass('fade-in')) {
										appended.addClass('fade-in');
									}
								},
							})
							.to(appended, {y: 50, alpha: 0, duration: 1, delay: 0.2})
							.to(
								appended,
								{
									y: 0,
									alpha: 1,
									duration: 1,
									ease: 'power4.out',
									stagger: 0.1 * invert,
								},
								'-=0.5'
							);
					}, 0);

					this.mm.add('(max-width: 991px)', () => {
						setTimeout(() => {
							window.scrollTo(0, $('.page-stories, .page-india-stories').find('.section-portfolio').offset().top - document.querySelector('.header').offsetHeight);
						}, 500);
					})

					this.mm.add('(min-width: 992px)', () => {
						setTimeout(() => {
							window.scroller.scrollTo(this.options.container.querySelector('.section-portfolio'), {
								duration: 100,
								offset: document.querySelector('.header').offsetHeight * -1,
							});
						}, 100);
					})
				},
				error: (result) => {
					console.log(JSON.stringify(result));
				},
			});
		}, 200);
	}

	loadMore = ({sectors, series, locations, search, nonce}, slug, page, scrollPosition, element) => {
		let pageId = $('.filter-wrap').data('page-id');
		let template = $('.stories-section').data('template');
		
			$.ajax({
			type: 'post',
			dataType: 'json',
			url: wp_ajax.ajaxurl,
			data: {
				action: 'load_more_stories',
				pageId,
				nonce,
				sectors,
				series,
				locations,
				search,
				slug,
				page,
				template,
			},
			success: (result) => {
				setTimeout(() => {
					const parent = $('.row-' + slug);
					parent.append(result.html);

					if (result.is_last) {
						$(`[data-slug='${slug}']`).hide();
					} else {
						$(`[data-slug='${slug}']`).html('Dive deeper');
						$(`[data-slug='${slug}']`).data('page', page);
					}

					const appended = $('.page-stories, .page-india-stories').find('.col:not(.fade-in)');

					gsap.set(appended, { alpha: 0 });
					gsap.set(parent.parent(), { height: '100%' });

					const invert = 1;

					// Set back scroll position to current position
					gsap.to(window, {
						scrollTo: {
							y: scrollPosition,
						},
						duration: 0,
						ease: 'power4.inOut',
					});
					// CHECK HERE
					setTimeout(() => {
						gsap
							.timeline({
								onStart: () => {
									if (!appended.hasClass('fade-in')) {
										appended.addClass('fade-in');
									}
								},
							})
							.to(appended, { y: 50, alpha: 0, duration: 1, delay: 0.2 })
							.to(
								appended,
								{
									y: 0,
									alpha: 1,
									duration: 1,
									ease: 'power4.out',
									stagger: 0.1 * invert,
								},
								'-=0.5'
							);
					}, 0);
				}, 0);

				if (this.smoother !== undefined) {
					this.smoother.refresh();
				}

				$(element).removeClass('disable-click');
			},
			error: (result) => {
				console.log(JSON.stringify(result));
				$(element).removeClass('disable-click');
			},
		});
	};

	filterCount = () => {
		let dropdowns = ['sector', 'series', 'location'];

		dropdowns.forEach((dropdown) => {
			let activeFilters = $(`#${dropdown}-filter input:checked`);
			let activeFiltersNumber = activeFilters.length;
			let selected = [];

			activeFilters.each((index, element) => {
				selected.push($(element).val());
			});

			if (selected.includes('all' || selected.length === 0)) {
				activeFiltersNumber -= 1;
			}

			if (activeFiltersNumber > 0)
				$(`#${dropdown}-filter .filter-count`).html(`(${activeFiltersNumber})`);
			else $(`#${dropdown}-filter .filter-count`).html('');
		});

		let number = $('.filter-wrap input:checked:not(.filter-all)').length;

		if (number) {
			$('.filter-opener .filter-count').html(`(${number})`);
			if (window.innerWidth > 768) {
				$('#reset-filters').fadeIn();
			}
		} else {
			$('#reset-filters').fadeOut();
			$('.filter-opener .filter-count').html('');
		}
	};

	// Reset all filters
	resetFilters = () => {
		$('.filter-wrap input:checked').prop('checked', false);
		$('.filter-all').prop('checked', true);
		$('#search').val('');
		$('form.search').removeClass('filled');
		this.previousSearch = '';
	};

	// Search autocomplete
	searchAutocomplete = () => {
		if (typeof window.storiesAutocomplete !== 'undefined') {
			$('.page-stories, .page-india-stories')
				.find('#search')
				.autocomplete({
					source: window.storiesAutocomplete,
					appendTo: $('.page-stories, .page-india-stories').find(
						'.filter-wrap .inner .search'
					)[0],
					minLength: 1,
					autoFocus: false,
					open: (e) => {
						$(e.target)
							.next('.ui-autocomplete')
							.addClass('is-active');
						if (!this.isSimpleBar) {
							this.initSimplebar();
						}
					},
					select: (event, ui) => {
						$(event.target).removeClass('active');
						$(event.target)
							.next('.ui-autocomplete')
							.removeClass('is-active');
					},
					close: () => {
						this.destroySimpleBar();
					},
					change: (event, ui) => {
						let value = $(event.target).val();
						value = decodeHTML(value);
						$(event.target).val(value);
					},
					response: (event, ui) => {
						ui.content.forEach((item) => {
							item.label = decodeHTML(item.label);
							item.value = decodeHTML(item.value);
						});
					},
				});
		}

		function decodeHTML(html) {
			let decodedValue = html
				.replace(/&#8217;/g, "'")
				.replace(/&#038;/g, '&');
			return decodedValue;
		}
	};

	initSimplebar() {
		this.isSimpleBar = true;
		this.SimpleBar = new SimpleBar(document.querySelector('.ui-autocomplete'));
	}

	destroySimpleBar() {
		if (this.isSimpleBar) {
			this.isSimpleBar = false;
			this.SimpleBar.unMount();
		}
	}

	getScrollPosition() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	destroyAutoComplete() {
		$('.page-stories #search, .page-india-stories #search').autocomplete('destroy');
		if (typeof window.storiesAutocomplete !== 'undefined') {
			window.storiesAutocomplete = undefined;
		}
	}

	destroy() {
		this.destroyAutoComplete();
		this.destroySimpleBar();
		this.destroyAccodion();
	}
}

export default StoriesFilters;